import React from 'react';
import './Button.css';
import {
    Button as MTLButton
} from '@mui/material/'

export function Button(props) {
    const { text, clickHandler, color = "primary" } = props;
    let localParams = {...props};

    console.log(localParams);
    if (localParams['text'] !== undefined){
        delete localParams['text'];
    }

    if (localParams['clickHandler'] !== undefined){
        delete localParams['clickHandler'];
    }

    if (localParams['color'] !== undefined){
        delete localParams['color'];
    }

    // delete localParams['clickHandler'];
    // delete localParams['color'];

    return (
        <>
            <div className="button">
                <MTLButton variant='contained' color={color} className={`text-uppercase`}
                           onClick={(e) => clickHandler(e)} {...localParams}>
                    {text}
                </MTLButton>
            </div>
        </>
    )
};